var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sticky-bottom fixed-bottom"},_vm._l((_vm.routerLinks),function(link,index){return _c('b-button',{key:index,staticClass:"mr-2",attrs:{"to":{ name: link.name },"id":`new_button${index}`,"variant":"primary"}},[_vm._v(" "+_vm._s(link.title || _vm.$t('menuItemNew'))+" "),_c('span',{staticClass:"pl-1 fa fa-plus"})])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }